<template>
  <div>
    <activity-component
      :activity="activity"
      :description="description"
    />
  </div>
</template>

<script>
import { getUserData } from '@/auth/utils';
import ActivityComponent from './ActivityComponent.vue';

export default {
  components: {
    ActivityComponent,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      self: getUserData(),
    }
  },
  computed: {
    description() {
      const { user, newStatus, oldStatus } = this.activity;
      const creator = user.uuid === this.self.uuid ? this.$t('You') : user.name;

      return `${creator} moved this task from <span style="padding: 2px 6px; border-radius: 4px; color: white; background-color:${oldStatus.color}; white-space: nowrap">${oldStatus.name}</span> to <span style="padding: 2px 6px; border-radius: 4px; color: white; background-color:${newStatus.color}; white-space: nowrap">${newStatus.name}</span>.`;
    },
  },
}
</script>
